import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import { withPrefix } from 'gatsby'
import React from 'react'
import { Tool } from '@/components/top-page/tool'
import * as Styles from './tool.module.scss'
import { Contact } from '@/components/general/contact'
import { Container } from '@/components/general/container'
import { Layout } from '@/components/general/layout'
import { PageTitle } from '@/components/general/page-title'
import { Seo } from '@/components/general/seo'





const ToolPage = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="機能一覧"
      description="クラウド決算開示管理サービス【Uniforce】の機能一覧。タスク・スケジュール自動作成機能や、決算開示資料ごとのタスク管理や、リアルタイム進捗レポート機能など、決算開示業務に特化したタスク管理を追求した機能。"
    />
    <PageTitle
      className={Styles.pageTitle}
      en="FUNCTION"
      title="主な機能"
      decorationLogo
      readText={
        <>
          決算開示業務を「最短・最適なルート」で
          <br className="sp" />
          ナビゲーションするための
          <br className="pc" />
          Uniforceの機能を
          <br className="sp" />
          ご紹介します。
        </>
      }
    >
      <div className={Styles.pageTitle_decoration_1}>
        <StaticImage
          src="../images/page-title_image_tool.png"
          height={183.28}
        />
      </div>
    </PageTitle>
    <section className={Styles.tool}>
      <div className={Styles.tool__box}>
        <Container>
          <div className={Styles.tool__box_inner}>
            <div className={Styles.tool__textarea}>
              <h2 className={Styles.tool__textarea_subtitle}>
                <img
                  src={withPrefix('/tool_icon_section-1.svg')}
                  alt=""
                  width={53.17}
                  height={52.6}
                />
                タスク・スケジュール自動生成機能
              </h2>
              <p className={Styles.tool__textarea_title}>
                決算開示業務に特化した
                <br />
                約1,200のタスクを初期生成
                <small>（1年間の決算開示業務に関する総タスク数）</small>
              </p>
              <p className={Styles.tool__textarea_text_pc}>
                8名に及ぶ公認会計士が作成したタスクリストと、
                <br className="pc" />
                スケジュールが自動生成されるので、
                <br className="pc" />
                面倒なタスク作成と納期設定は必要ありません。
              </p>
              <div
                className={classNames(
                  Styles.tool__textarea_img_sp,
                  Styles.tool__textarea_img_sp__1
                )}
              >
                <StaticImage
                  src="../images/tool_image_section-1.png"
                  alt=""
                  width={403}
                />
              </div>
              <ul>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-1-1.svg')}
                    alt=""
                    width={34.69}
                    height={36}
                  />
                  <p>
                    スケジュール
                    <br />
                    自動生成
                  </p>
                </li>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-1-2.svg')}
                    alt=""
                    width={32.67}
                    height={39.37}
                  />
                  <p>
                    タスク
                    <br />
                    テンプレート化
                  </p>
                </li>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-1-3.svg')}
                    alt=""
                    width={26.67}
                    height={24.34}
                    style={{
                      marginTop: '12px',
                    }}
                  />
                  <p>柔軟なフィルタリング</p>
                </li>
              </ul>
              <p className={Styles.tool__textarea_text_sp}>
                決算開示業務に特化したテンプレートで、
                タスクリストとスケジュールを自動生成。
                面倒なタスク作成と納期設定は必要ありません。
              </p>
            </div>
            <div className={Styles.tool__textarea_img_pc}>
              <StaticImage
                src="../images/tool_image_section-1.png"
                alt=""
                width={633}
              />
            </div>
          </div>
        </Container>
      </div>
      <div className={Styles.tool__box}>
        <Container>
          <div className={Styles.tool__box_inner_row}>
            <div className={Styles.tool__textarea}>
              <p className={Styles.tool__textarea_subtitle}>
                <img
                  src={withPrefix('/tool_icon_section-2.svg')}
                  alt=""
                  width={42}
                  height={39}
                />
                リアルタイムレポート機能
              </p>
              <p className={Styles.tool__textarea_title}>
                プロジェクトの進捗を
                <br />
                リアルタイムで把握
              </p>
              <p className={Styles.tool__textarea_text_pc}>
                プロジェクト全体の進捗から、各タスクの進捗まで
                把握できるリアルタイムレポート機能で資料単位での進捗や
                遅延しているタスクが一目でわかります。
              </p>
              <div
                className={classNames(
                  Styles.tool__textarea_img_sp,
                  Styles.tool__textarea_img_sp__2
                )}
              >
                <StaticImage
                  src="../images/tool_image_section-2.png"
                  alt=""
                  width={374}
                />
              </div>
              <ul>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-2-1.svg')}
                    alt=""
                    width={37.35}
                    height={32.63}
                  />
                  <p>
                    書類進捗
                    <br />
                    サマリー
                  </p>
                </li>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-2-2.svg')}
                    alt=""
                    width={61.35}
                    height={31.21}
                  />
                  <p>
                    前年度との
                    <br />
                    比較
                  </p>
                </li>
              </ul>
              <p className={Styles.tool__textarea_text_sp}>
                プロジェクト全体の進捗から、各タスクの進捗まで
                <br className="pc" />
                把握できるリアルタイムレポート機能で資料単位での進捗や
                <br className="pc" />
                遅延しているタスクが一目でわかります。
              </p>
            </div>
            <div className={Styles.tool__textarea_img_pc}>
              <StaticImage
                src="../images/tool_image_section-2.png"
                alt=""
                width={722}
              />
            </div>
          </div>
        </Container>
      </div>
      <div className={Styles.tool__box}>
        <Container>
          <div className={Styles.tool__box_inner}>
            <div className={Styles.tool__textarea}>
              <p className={Styles.tool__textarea_subtitle}>
                <img
                  src={withPrefix('/tool_icon_section-3.svg')}
                  alt=""
                  width={34}
                  height={42}
                />
                通知・アラート機能
              </p>
              <h2 className={Styles.tool__textarea_title}>
                タスク確認の
                <br />
                抜け漏れをなくす細かな通知
              </h2>
              <p className={Styles.tool__textarea_text_pc}>
                期限切れのタスク表示や書類の提出期限など、やらなければいけないタスクや、提出までの期限が短い書類などをすぐに確認することが可能です。優先的に作業するべきものを一覧で確認することができます。
              </p>
              <div
                className={classNames(
                  Styles.tool__textarea_img_sp,
                  Styles.tool__textarea_img_sp__3
                )}
              >
                <StaticImage
                  src="../images/tool_image_section-3.png"
                  alt=""
                  width={331}
                />
              </div>
              <ul>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-3-1.svg')}
                    alt=""
                    width={34.07}
                    height={39.27}
                  />
                  <p>
                    期限切れタスク
                    <br />
                    の表示
                  </p>
                </li>
                <li>
                  <img
                    src={withPrefix('/tool_icon_section-3-2.svg')}
                    alt=""
                    width={30.66}
                    height={34.08}
                  />
                  <p>
                    決算書類の
                    <br />
                    期限日表示
                  </p>
                </li>
              </ul>
              <p className={Styles.tool__textarea_text_sp}>
                期限切れのタスク表示や書類の提出期限など、やらなければいけないタスクや、提出までの期限が短い書類などをすぐに確認することが可能です。優先的に作業するべきものを一覧で確認することができます。
              </p>
            </div>
            <div className={Styles.tool__textarea_img_pc}>
              <StaticImage
                src="../images/tool_image_section-3.png"
                alt=""
                width={496}
              />
            </div>
          </div>
        </Container>
      </div>
    </section>

    <Tool sectionTitle="その他の機能" className={Styles.others} />

    <Contact />
  </Layout>
)

export default ToolPage
